interface TalentNameParts {
  firstName?: string;
  middleName?: string;
  lastName?: string;
}

/**
 * Builds a talent's display name from firstName, middleName and lastName.
 * Only parts with at least one non-space character are included, so empty
 * strings or whitespace-only values are skipped. Each included part is trimmed
 * and joined with a single space.
 */
function getTalentFullName(talent: TalentNameParts | null | undefined): string {
  if (!talent) return "";
  return [talent.firstName, talent.middleName, talent.lastName]
    .filter((part): part is string => typeof part === "string" && part.trim().length > 0)
    .map((part) => part.trim())
    .join(" ");
}

export default getTalentFullName;
